<template>
  <div class="fforwarding-main">
    <Menus :menu="menu" icon="https://dsmapi.logistics.systems/dsm6gicons/icons8-supplier-64.png" @menuClicked="menuClicked"/>
    <div class="right-container">
      <Tabulator id="tab_tabulator" tableID="jobTabulator" tableTitle="Jobs" :tableData="jobData" :multiSelect="1" :rowsCount="rows"
        :disabled="tabulatorDisable" :selectedRow.sync="selectedJob" ref="selectUser"/>
    </div>
    <EntryPopup :show.sync="showPopup" :content="entryContent" :title="entryTitle" @saved="saveClicked" :requiredError="Rmessages" :messages.sync="messages" :errorMessages.sync="Emessages" :successMessages="Smessages"
      :updatedBy="updatedBy" :createdBy="createdBy" ref="ePopup" @rendered="entryPopupRendered" :isComponent="true" :newStyle="true"
      :viewMode="viewMode" />
		<Loader :isVisible="loading" :loadingText="loadText" />
  </div>
</template>

<script>
/* eslint-disable */
import EntryPopup from '@/components/EntryPopup.vue';
import Tabulator from '@/components/Tabulator.vue';
import Loader from '@/components/Loader.vue';
import Menus from '@/components/Menus.vue';

export default {
  components: {
    EntryPopup, Tabulator, Loader, Menus
  },
  props: {
    jobData: { type: Array, default: function() { return [] } },
    loadText: { type: String, default: 'Loading' },
    loading: { type: Boolean, default: false },
    menu: { type: Array, default: function() { return [
      { title: 'New Job', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png' },
      { title: 'Edit Job', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-edit-64%20(1).png' },
      { title: 'Delete Job', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png' },
      { title: 'View Job', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png' }
    ] } },
    selectedJob: { type: Array, default: function() { return [] } },
    entryContent: { type: Array, default: function() { return {
      type: 'FreightPopup',
      popupData: {
        jobIndicators: [],

        jobType: '',
        transMode: [],
        cargoType: [],
        shipper: [],
        consignee: [],
        notifyParty: [],

        projectNo: {},
        custRefNo: '',
        vbkgRefNo: '',
        billTo: [], selectedBillTo: null,
        status: {},
        outstanding: '',
        creditLimit: '',
        creditTerms: '',

        jobNo: '',
        creditTerms: {},
        jobStatus: '',

        // Tab data
        quickEntry: {},
        generalDetails: {},
        shippingInfo: {
          transNoPlaceholder: 'Ship Call #',
          transIDPlaceholder: 'Vessel ID',
          transAgentPlaceholder: 'Shipping Agent',
          transLinePlaceholder: 'Shipping Line',
        },
        cargoInfo: {},
        deliveryNote: {},
        ROT: {},
        TASKPI: {},
        SMK: {},
      }
		} } },
    showPopup: { type: Boolean, default: false },
    viewMode: { type: Boolean, default: false },
    entryTitle: { type: String, default: '' },
    updatedBy: { type: String, default: '' },
    createdBy: { type: String, default: '' },
  },
  methods: {
    menuClicked: function(e) {
      switch (e.title) {
        case 'New Job':
          this.newJob();
          break;
        case 'Edit Job':
          this.viewEditClicked('edit');
          break;
        case 'Delete Job':
					this.deleteClicked();
					break;
        case 'View Job':
          this.viewEditClicked('view');
          break;
      }
    },
    newJob: function() {
      this.entryTitle = 'New Job';
      this.showPopup = true;
    },
    viewEditClicked: async function(status) {
      if (this.selectedJob.length > 0) {
        
      } else {
        this.$showAlert('error', 'No Job Selected', `Please select a record to ${status}`);
      }
    },
    deleteClicked: function() {
      console.log('Delete Job');
    },
    saveClicked: function() {
      console.log(this.entryContent.popupData);
    },
		// Populating Tabs
		
    // Populating Tabs
		// Tabs bus events
		
    // Tabs bus events
  },
  async mounted() {
    this.loading = true;

    this.loadText = 'Getting Jobs';
    var jobsList = await this.$apiCallV2('/FreightForwarding/GetListJobTracking');
    this.jobData = jobsList.data;

    this.loadText = 'Getting Notify Party';
    var notifyPartyList = await this.$apiCallV2('/FreightForwarding/GetListMaster?masterFile=notifyparty');
    this.entryContent.popupData.notifyParty = notifyPartyList.data;

    this.loadText = 'Getting Consignee';
    var consigneeList = await this.$apiCallV2('/FreightForwarding/GetListMaster?masterFile=consignee');
    this.entryContent.popupData.consignee = consigneeList.data;

    this.loadText = 'Getting Shipper';
    var shipperList = await this.$apiCallV2('/FreightForwarding/GetListMaster?masterFile=shipper');
    this.entryContent.popupData.shipper = shipperList.data;

    this.loadText = 'Getting Cargo Type';
    var cargoTypeList = await this.$apiCallV2('/FreightForwarding/GetListMaster?masterFile=cargotype');
    this.entryContent.popupData.cargoType = cargoTypeList.data;

    this.loadText = 'Getting Trans Mode';
    var transModeList = await this.$apiCallV2('/FreightForwarding/GetListMaster?masterFile=transmode');
    this.entryContent.popupData.transMode = transModeList.data;

    this.loadText = 'Getting Job Type';
    var jobTypeList = await this.$apiCallV2('/FreightForwarding/GetListMaster?masterFile=jobtype&module=FMS');
    this.entryContent.popupData.jobType = jobTypeList.data;

    this.loadText = 'Getting Customer';
    var billToList = await this.$apiCallV2('/FreightForwarding/GetListMaster?masterFile=billcust');
    this.entryContent.popupData.billTo = billToList.data;

    this.loading = false;
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.fforwarding-main {
  width: 100%;
  height: 100%;
  display: flex;
  // background-color: yellow;
  padding: 3px 45px;
  font-size: 12px;
}

.right-container {
  width: 100%;
  overflow: hidden;
  height: 100%;
  padding-left: 5px;
  // background-color: limegreen;
}
</style>